import React from 'react';
import { Card, Typography, Divider, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy: React.FC = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div style={{
            background: 'linear-gradient(135deg, #fef4f4 0%, #fff9f9 100%)',
            minHeight: '100vh',
            padding: isMobile ? '20px' : '40px'
        }}>
            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate('/')}
                    style={{ marginBottom: '24px' }}
                >
                    Torna alla Home
                </Button>

                <Card style={{
                    borderRadius: '16px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                }}>
                    <Title level={1} style={{ textAlign: 'center', marginBottom: '8px' }}>
                        Privacy Policy
                    </Title>
                    <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: '32px' }}>
                        Ultimo aggiornamento: 11 Novembre 2024
                    </Text>

                    <Divider />

                    <Title level={3}>1. Introduzione</Title>
                    <Paragraph>
                        La presente Privacy Policy descrive come babbonatalesegreto.icu ("noi", "nostro/a") raccoglie,
                        utilizza e protegge i dati personali degli utenti in conformità al Regolamento Generale sulla
                        Protezione dei Dati (GDPR - Regolamento UE 2016/679).
                    </Paragraph>

                    <Title level={3}>2. Titolare del Trattamento</Title>
                    <Paragraph>
                        Il Titolare del trattamento dei dati è babbonatalesegreto.icu.<br />
                        Per qualsiasi richiesta relativa ai tuoi dati personali, puoi contattarci all'indirizzo email:
                        <a href="mailto:info@marchiosoft.com" style={{ marginLeft: '4px' }}>info@marchiosoft.com</a>
                    </Paragraph>

                    <Title level={3}>3. Dati Raccolti</Title>
                    <Paragraph>
                        Durante l'utilizzo del servizio, raccogliamo e trattiamo le seguenti categorie di dati personali:
                    </Paragraph>
                    <ul>
                        <li><Text strong>Dati di autenticazione:</Text> Email, nome, cognome e avatar (forniti tramite Auth0)</li>
                        <li><Text strong>Dati dei partecipanti:</Text> Indirizzi email dei partecipanti ai sorteggi</li>
                        <li><Text strong>Dati del sorteggio:</Text> Titolo del sorteggio, esclusioni e abbinamenti generati</li>
                        <li><Text strong>Dati tecnici:</Text> Indirizzo IP, tipo di browser, timestamp delle operazioni</li>
                    </ul>

                    <Title level={3}>4. Base Giuridica e Finalità del Trattamento</Title>
                    <Paragraph>
                        I tuoi dati personali vengono trattati per le seguenti finalità:
                    </Paragraph>
                    <ul>
                        <li><Text strong>Erogazione del servizio</Text> (base giuridica: esecuzione del contratto) -
                        gestione dell'account, creazione e gestione dei sorteggi</li>
                        <li><Text strong>Autenticazione e sicurezza</Text> (base giuridica: interesse legittimo) -
                        protezione dell'account e prevenzione accessi non autorizzati</li>
                        <li><Text strong>Invio email ai partecipanti</Text> (base giuridica: consenso) -
                        notifica dei risultati del sorteggio tramite email</li>
                        <li><Text strong>Conformità legale</Text> (base giuridica: obbligo di legge) -
                        rispetto degli obblighi normativi</li>
                    </ul>

                    <Title level={3}>5. Condivisione dei Dati</Title>
                    <Paragraph>
                        I tuoi dati personali possono essere condivisi con:
                    </Paragraph>
                    <ul>
                        <li><Text strong>Auth0:</Text> Fornitore del servizio di autenticazione (Privacy Policy:
                        <a href="https://auth0.com/privacy" target="_blank" rel="noopener noreferrer"> auth0.com/privacy</a>)</li>
                        <li><Text strong>Servizio Email:</Text> Provider utilizzato per l'invio delle notifiche</li>
                        <li><Text strong>Hosting Provider:</Text> Per l'archiviazione dei dati su server sicuri</li>
                    </ul>
                    <Paragraph>
                        Non vendiamo né cediamo i tuoi dati personali a terze parti per scopi di marketing.
                    </Paragraph>

                    <Title level={3}>6. Conservazione dei Dati</Title>
                    <Paragraph>
                        I dati personali vengono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti:
                    </Paragraph>
                    <ul>
                        <li>Dati dell'account: fino alla cancellazione dell'account o richiesta di eliminazione</li>
                        <li>Dati dei sorteggi: fino all'eliminazione manuale del sorteggio da parte dell'utente</li>
                        <li>Log tecnici: massimo 12 mesi per finalità di sicurezza</li>
                    </ul>

                    <Title level={3}>7. I Tuoi Diritti (GDPR)</Title>
                    <Paragraph>
                        In conformità al GDPR, hai diritto a:
                    </Paragraph>
                    <ul>
                        <li><Text strong>Accesso:</Text> Ottenere conferma del trattamento e copia dei tuoi dati</li>
                        <li><Text strong>Rettifica:</Text> Correggere dati inesatti o incompleti</li>
                        <li><Text strong>Cancellazione:</Text> Richiedere l'eliminazione dei tuoi dati ("diritto all'oblio")</li>
                        <li><Text strong>Limitazione:</Text> Limitare il trattamento in determinate circostanze</li>
                        <li><Text strong>Portabilità:</Text> Ricevere i tuoi dati in formato strutturato</li>
                        <li><Text strong>Opposizione:</Text> Opporti al trattamento per motivi legittimi</li>
                        <li><Text strong>Revoca consenso:</Text> Revocare il consenso in qualsiasi momento</li>
                    </ul>
                    <Paragraph>
                        Per esercitare i tuoi diritti, contattaci via email. Hai inoltre il diritto di proporre reclamo
                        all'Autorità Garante per la Protezione dei Dati Personali.
                    </Paragraph>

                    <Title level={3}>8. Sicurezza dei Dati</Title>
                    <Paragraph>
                        Adottiamo misure tecniche e organizzative adeguate per proteggere i tuoi dati personali da
                        accessi non autorizzati, perdita, distruzione o alterazione, tra cui:
                    </Paragraph>
                    <ul>
                        <li>Crittografia dei dati in transito (HTTPS/TLS)</li>
                        <li>Autenticazione sicura tramite Auth0</li>
                        <li>Backup periodici dei dati</li>
                        <li>Accesso limitato ai dati solo al personale autorizzato</li>
                    </ul>

                    <Title level={3}>9. Cookie e Tecnologie Simili</Title>
                    <Paragraph>
                        Il sito utilizza esclusivamente cookie tecnici necessari per il funzionamento del servizio di
                        autenticazione (Auth0). Per maggiori informazioni, consulta la nostra
                        <a href="/cookies" style={{ marginLeft: '4px' }}>Cookie Policy</a>.
                    </Paragraph>

                    <Title level={3}>10. Modifiche alla Privacy Policy</Title>
                    <Paragraph>
                        Ci riserviamo il diritto di modificare la presente Privacy Policy in qualsiasi momento.
                        Le modifiche sostanziali saranno comunicate tramite email o notifica sul sito. Ti invitiamo
                        a consultare periodicamente questa pagina.
                    </Paragraph>

                    <Title level={3}>11. Contatti</Title>
                    <Paragraph>
                        Per qualsiasi domanda relativa alla presente Privacy Policy o per esercitare i tuoi diritti,
                        puoi contattarci all'indirizzo email:
                        <a href="mailto:info@marchiosoft.com" style={{ marginLeft: '4px' }}>info@marchiosoft.com</a>
                    </Paragraph>

                    <Divider />

                    <div style={{ textAlign: 'center', marginTop: '32px' }}>
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => navigate('/')}
                        >
                            Torna alla Home
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
